import React from "react";

export type SwitchUserFormAdditionalActionsContextType = {
  onSubmitEditingAll(): Promise<any> | any;
};

export const SwitchUserFormAdditionalActionsContext = React.createContext<
  SwitchUserFormAdditionalActionsContextType | undefined
>(undefined);
